module.exports = __webpack_public_path__ + "static/poster-service-page-286221699292d9a8be18625c3bf18e16.jpeg";